var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { ReactComponent as CloseIcon } from '../../../../assets/images/closeIcon.svg';
import { DynamicFormBuilderContainer } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { Typography } from '@mui/material';
var ParametersCheckedRefValueMobileView = function (_ref) {
    var data = _ref.data, onClose = _ref.onClose;
    var referncevaluesElements = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            p: 1.5,
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    containerProps: {
                        m: 0
                    },
                    sx: {
                        padding: '12px 16px',
                        bgcolor: 'secondary.50',
                        border: 'none'
                    },
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            xs: 12,
                            spacing: 0,
                            justifyContent: 'end',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'ParameterBeforeRepair',
                                    label: 'Parameter before repair',
                                    columnSize: true,
                                    labelTypographyProps: {
                                        m: 0
                                    },
                                    fontSize: 'sm',
                                    fontWeight: 'medium'
                                }]
                        }, {
                            type: FormItemTypes.Divider,
                            name: 'name',
                            variant: 'fullWidth',
                            columnSize: 12,
                            containerProps: {
                                sx: {
                                    display: {
                                        sm: 'none'
                                    }
                                }
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            justifyContent: 'end',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'ParameterAfterRepair',
                                    label: 'Parameter after repair',
                                    columnSize: true,
                                    labelTypographyProps: {
                                        m: 0
                                    },
                                    fontSize: 'sm',
                                    fontWeight: 'medium'
                                }]
                        }, {
                            type: FormItemTypes.Divider,
                            name: 'name',
                            variant: 'fullWidth',
                            columnSize: 12,
                            containerProps: {
                                sx: {
                                    display: {
                                        sm: 'none'
                                    }
                                }
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            xs: 12,
                            sm: 12,
                            md: 6,
                            lg: 6,
                            spacing: 0,
                            justifyContent: 'end',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'ObservationBeforeRapair',
                                    label: 'Observation before repair',
                                    columnSize: true,
                                    labelTypographyProps: {
                                        m: 0
                                    },
                                    fontSize: 'sm',
                                    fontWeight: 'medium'
                                }]
                        }, {
                            type: FormItemTypes.Divider,
                            name: 'name',
                            variant: 'fullWidth',
                            columnSize: 12,
                            containerProps: {
                                sx: {
                                    display: {
                                        sm: 'none'
                                    }
                                }
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            xs: 12,
                            sm: 12,
                            md: 6,
                            lg: 6,
                            spacing: 0,
                            justifyContent: 'end',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'ObservationAfterRapair',
                                    label: 'Observation after repair',
                                    columnSize: true,
                                    labelTypographyProps: {
                                        m: 0
                                    },
                                    fontSize: 'sm',
                                    fontWeight: 'medium'
                                }]
                        }]
                }]
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            padding: '20px',
            borderBottom: '1px solid',
            borderColor: 'secondary.200',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: "Title",
                    children: 'Parameters checked',
                    columnSize: true,
                    fontSize: 'xl',
                    fontWeight: 'strong'
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "text.secondary",
                        height: '12px',
                        width: '12px'
                    }),
                    columnSize: 0,
                    onClick: function () {
                        onClose(false);
                    },
                    sx: {
                        padding: '12px'
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ReferanceValueData',
            columnSize: 12,
            spacing: 0,
            p: 2,
            elements: [{
                    type: FormItemTypes.List,
                    name: 'ReferanceValueData',
                    columnSize: 12,
                    value: [{
                            id: 1
                        }, {
                            id: 2
                        }],
                    variant: 'compact',
                    disableCheckboxSelection: true,
                    columns: [{
                            field: 'Part',
                            flex: 1,
                            renderCell: function (params) {
                                var _params$row;
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                    fontWeight: "medium"
                                }, "".concat(params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.FieldFailureReportDocumentName)));
                            }
                        }],
                    elements: referncevaluesElements
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ({
                        data: data,
                        success: true
                    })];
            });
        }); },
        gridProps: {
            spacing: 0
        }
    }));
};
export default ParametersCheckedRefValueMobileView;
